var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCirclePause(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 21 21",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.38 0a10.38 10.38 0 100 20.76 10.38 10.38 0 000-20.76zM9.12 14.92h-2.6L6.5 6.03h2.59l.04 8.9zm5.15 0h-2.6V6.03h2.6v8.9z"
  })));
}

export default __webpack_public_path__ + "media/images/styleguide/icons/icon-circle--pause-1cc588c7a914eac189262b14da7ce590.svg";
export { SvgIconCirclePause as Component };